import {RootLayout, RsnLogoSpinner} from '@raison/ui-kit';
import React, {PropsWithChildren} from 'react';
import {PullToRefreshContainer} from '~/shared/layouts/PullToRefreshContainer';
import {useHomeRefresh} from './RefreshButton/RefreshButton';

export function HomeDashboardLayout({children}: PropsWithChildren<{}>) {
    return <div className={`flex flex-col gap-4 px-4`}>{children}</div>;
}

export function HomeToastsLayout({children}: PropsWithChildren<{}>) {
    return <div className='flex flex-col gap-2 first:*:mt-4'>{children}</div>;
}

export function HomeLinksLayout({children}: PropsWithChildren<{}>) {
    return (
        <div className={`my-5 list-none divide-y divide-solid divide-neutral-30 rounded-lg bg-neutral-10`}>
            {children}
        </div>
    );
}

export function HomePageLayout({children, noRefresh = false}: PropsWithChildren<{noRefresh?: boolean}>) {
    const [refresh, isRefreshing] = useHomeRefresh();
    if (!noRefresh) {
        children = (
            <PullToRefreshContainer
                onRefresh={refresh}
                isRefreshing={isRefreshing}
                spinner={<RsnLogoSpinner size={24} />}
            >
                {children}
            </PullToRefreshContainer>
        );
    }
    return (
        <RootLayout
            background='none'
            pageHeader={<RootLayout.LogoHeader align='center' />}
            menuHeader={<RootLayout.LogoHeader align='center' />}
        >
            {children}
        </RootLayout>
    );
}
